<template>
  <div class="container">
    <div class="search-container">
      <input
        type="text"
        placeholder="Search by Name"
        v-model="searchInput"
        @input="highSchoolSearch"
      />
    </div>

    <div class="box-container">
      <table>
        <tr>
          <th></th>
          <th
            style="cursor: pointer"
            @click="order == 'asc' ? order = 'desc' : order = 'asc'"
          >Name {{order == 'asc' ? '&#9650;' : '&#9660;' }}</th>
          <th>City</th>
          <th>
            <span>State</span>
            <select v-model="state">
              <option value disabled selected hidden>Filter</option>
              <option v-for="(state, index) in states" :key="index" :value="state">{{state}}</option>
            </select>
          </th>
          <th>
            <span>Type</span>
            <select v-model="isPrivate">
              <option value disabled selected hidden>Filter</option>
              <option :value="false">Type Public</option>
              <option :value="true">Type Private</option>
            </select>
          </th>
        </tr>

        <tr v-for="(school, index) in highSchools" :key="index">
          <td></td>
          <td>
            <a @click="$router.push(`/highSchools/${school.id}`)">{{school.name}}</a>
          </td>
          <td>{{school.city}}</td>
          <td class="state">{{school.state}}</td>
          <td class="type">{{school.isPrivate ? 'Private' : 'Public'}}</td>
        </tr>
      </table>

      <div class="btn-container">
        <button class="loadmore" @click="loadMore">Load More</button>
      </div>
    </div>
  </div>
</template>

<script>
import { states } from "../db";
import { db } from "../db";
export default {
  data() {
    return {
      baseQuery: db.collection("highSchools").limit(30),
      currentQuery: null,
      highSchools: [],
      order: "asc",
      states: states,
      state: "",
      isPrivate: "",
      last: null,
      searchInput: ""
    };
  },
  created() {
    this.executeQuery();
  },
  methods: {
    queryBuilder() {
      this.currentQuery = this.baseQuery.orderBy("searchName", this.order);

      if (this.state !== "" && this.state !== null) {
        this.currentQuery = this.currentQuery.where("state", "==", this.state);
      }

      if (this.isPrivate !== "" && this.isPrivate !== null) {
        this.currentQuery = this.currentQuery.where(
          "isPrivate",
          "==",
          this.isPrivate
        );
      }

      if (this.searchInput !== "" && this.searchInput !== null) {
        const start = this.searchInput.toLowerCase();
        const end = start + "\uf8ff";

        this.order == "asc"
          ? (this.currentQuery = this.currentQuery.startAt(start).endAt(end))
          : (this.currentQuery = this.currentQuery.startAt(end).endAt(start));
      }
    },
    executeQuery() {
      this.queryBuilder();
      this.currentQuery.get().then(snap => {
        this.highSchools = snap.docs.map(doc => {
          return {
            ...doc.data(),
            id: doc.id
          };
        });

        this.last = snap.docs[snap.docs.length - 1];
      });
    },
    loadMore() {
      if (this.last) {
        this.currentQuery
          .startAfter(this.last)
          .get()
          .then(snap => {
            if (snap.empty) {
              alert("no more items to load");
            } else {
              this.last = snap.docs[snap.docs.length - 1];
              const moreSchools = snap.docs.map(doc => {
                return {
                  ...doc.data(),
                  id: doc.id
                };
              });

              this.highSchools = [...this.highSchools, ...moreSchools];
            }
          });
      }
    },
    highSchoolSearch() {
      this.executeQuery();
    }
  },
  watch: {
    order() {
      this.executeQuery();
    },
    state() {
      this.executeQuery();
    },
    isPrivate() {
      this.executeQuery();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>